"use client";

import { Badge } from "@/components/catalyst/badge";
import { useState, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";

interface TagFilterProps {
  tags: string[];
}

const TagFilter = ({ tags }: TagFilterProps) => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const urlTags = searchParams.get("tags")?.split(",") || [];
    setSelectedTags(urlTags);
  }, [searchParams]);

  const handleTagClick = (tag: string) => {
    const isSelected = selectedTags.includes(tag);

    let updatedTags: string[];
    if (isSelected) {
      updatedTags = selectedTags.filter((t) => t !== tag);
    } else {
      updatedTags = [...selectedTags, tag];
    }

    setSelectedTags(updatedTags);

    if (updatedTags.length === 0) {
      router.push("/thoughts");
    } else {
      router.push(`/thoughts?tags=${updatedTags.join(",")}`);
    }
  };

  return (
    <div className="my-4 flex w-full cursor-pointer select-none flex-wrap gap-2">
      {tags.map((tag) => (
        <Badge
          key={tag}
          color={selectedTags.includes(tag) ? "teal" : "zinc"}
          onClick={() => handleTagClick(tag)}
          className="cursor-pointer capitalize"
        >
          {tag}
        </Badge>
      ))}
    </div>
  );
};

export default TagFilter;
